export default "__VITE_ASSET__jbwY0J3x__"